'use strict';

export function init() {
    if (!document.querySelector('.eventSticky')) {
        return;
    }

    const alerts = document.querySelector('.eventSticky');


    const setStickyHeight = () => {
        const alertsHeight = alerts ? alerts.getBoundingClientRect().height : 0;

        document.documentElement.style.setProperty(
            '--event-sticky-height', `${alertsHeight-1}px`
        );
    };

    // Use a ResizeObserver to detect changes in the size of .eventSticky
    if ('ResizeObserver' in window && alerts) {
        const resizeObserver = new ResizeObserver(() => {
            setStickyHeight();
        });
        resizeObserver.observe(alerts);
    }

    setStickyHeight();
    window.addEventListener('resize', setStickyHeight);
}
